export const init = async function() {
    let isLinkHovered = false;
    document.querySelectorAll('.js-header-link').forEach((link)=>{
        const showDropdown = (target)=>{
            const parent = target.parentElement;
            if (parent) {
                const dropdown = parent.querySelector('.js-header-dropdown');
                if (dropdown) {
                    target.setAttribute('aria-expanded', 'true');
                }
            }
        };
        const hideDropdown = (target)=>{
            const parent = target.parentElement;
            if (parent) {
                const dropdown = parent.querySelector('.js-header-dropdown');
                if (dropdown && !isLinkHovered) {
                    target.setAttribute('aria-expanded', 'false');
                }
            }
        };
        link.addEventListener('mouseenter', (event)=>{
            const target = event.target;
            isLinkHovered = true;
            if (target instanceof HTMLElement) {
                showDropdown(target);
            }
        });
        link.addEventListener('mouseleave', (event)=>{
            const target = event.target;
            isLinkHovered = false;
            if (target instanceof HTMLElement) {
                setTimeout(()=>{
                    hideDropdown(target);
                }, 10);
            }
        });
        const parent = link.parentElement;
        if (parent) {
            const dropdown = parent.querySelector('.js-header-dropdown');
            if (dropdown) {
                dropdown.addEventListener('mouseenter', ()=>{
                    isLinkHovered = true;
                    if (link instanceof HTMLElement) {
                        showDropdown(link);
                    }
                });
                dropdown.addEventListener('mouseleave', ()=>{
                    isLinkHovered = false;
                    if (link instanceof HTMLElement) {
                        setTimeout(()=>{
                            hideDropdown(link);
                        }, 10);
                    }
                });
            }
        }
        link.addEventListener('mouseenter', ()=>{
            document.querySelectorAll('.js-header-link').forEach((otherLink)=>{
                if (otherLink !== link) {
                    otherLink.setAttribute('aria-expanded', 'false');
                }
            });
        });
    });
};
